import { render } from "./transaction-details.vue?vue&type=template&id=ce3f4c2c&scoped=true"
import script from "./transaction-details.vue?vue&type=script&lang=js"
export * from "./transaction-details.vue?vue&type=script&lang=js"

import "./transaction-details.vue?vue&type=style&index=0&id=ce3f4c2c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3f4c2c"]])

export default __exports__